// extracted by mini-css-extract-plugin
module.exports = {"h1":"Home_h1__186FU","h2":"Home_h2__2aAzJ","imgBook":"Home_imgBook__3OsYW"};